import { state } from "./State";

export const getState = () => {
  return state;
};
